import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Typography } from 'antd';
import ControlledOptionsFieldArray from '../../../components/mobile/form-helpers/ControlledOptionsFieldArray';

const { Title, Paragraph } = Typography;

function MobileMentalHealthCompleteSurvey({
  bodyStyle,
  titleStyle,
  isRedColor,
  text,
  heading,
  options,
  instruction
}) {

  const { t } = useTranslation();
  const { heading: instructionHeading, paragraph, paragraph1 } = instruction;

  return (
    <Box {...bodyStyle}>
      <Box paddingBottom={20} {...titleStyle}>
        <Title level={4} className="text-center">
          {t(heading)}
        </Title>
      </Box>
      <Box marginBottom={10} padding="10px" background={isRedColor ? "#FAAD141A" : "#15E1981A"}>
        {heading && <Title level={4} className="text-center">{t(instructionHeading)}</Title>}
        <Paragraph>
          {t(paragraph)}
        </Paragraph>
        <Paragraph>
          {t(paragraph1)}
        </Paragraph>
      </Box>
      <Paragraph marginBottom={20}>
        {t(text)}
      </Paragraph>
      {options && <ControlledOptionsFieldArray options={options.filter(option => option.value !== "")} isMultiSelect={false} />}
    </Box>
  );
}

MobileMentalHealthCompleteSurvey.defaultProps = {
  questions: [],
  bodyStyle: {},
  titleStyle: {},
  instruction: {},
  options: [],
  isRedColor: false,
  heading: "",
  text: ""
};

const { shape, string, bool } = PropTypes;

MobileMentalHealthCompleteSurvey.propTypes = {
  questions: shape([]),
  instruction: shape({}),
  bodyStyle: shape({}),
  titleStyle: shape({}),
  options: shape([]),
  isRedColor: bool,
  text: string,
  heading: string
};

export default MobileMentalHealthCompleteSurvey;
